import { useEffect, useState } from 'react'
import { Button, Dialog, Input } from '@/components/ui'
import { trpc } from '@/lib/trpc'

interface State {
  open: boolean
  edit?: {
    id: string
    name: string
    role: string | null
    email: string | null
    phone: string | null
    isPrimary: boolean
  }
}

const EMPTY = { name: '', role: '', email: '', phone: '', isPrimary: false }

export function ContactDialog({
  customerId,
  state,
  onClose,
}: {
  customerId: string
  state: State
  onClose: () => void
}) {
  const utils = trpc.useUtils()
  const [f, setF] = useState<Record<string, any>>(EMPTY)

  useEffect(() => {
    if (state.open) {
      setF(
        state.edit
          ? {
              name: state.edit.name,
              role: state.edit.role ?? '',
              email: state.edit.email ?? '',
              phone: state.edit.phone ?? '',
              isPrimary: state.edit.isPrimary,
            }
          : EMPTY,
      )
    }
  }, [state.open, state.edit])

  const done = () => {
    utils.customer.get.invalidate({ id: customerId })
    onClose()
  }
  const add = trpc.customer.addContact.useMutation({ onSuccess: done })
  const upd = trpc.customer.updateContact.useMutation({ onSuccess: done })

  const submit = () => {
    if (!f.name.trim()) return
    const payload = {
      name: f.name.trim(),
      role: f.role || null,
      email: f.email || null,
      phone: f.phone || null,
      isPrimary: !!f.isPrimary,
    }
    if (state.edit) upd.mutate({ id: state.edit.id, customerId, ...payload })
    else add.mutate({ customerId, ...payload })
  }

  return (
    <Dialog
      open={state.open}
      onOpenChange={(v) => !v && onClose()}
      title={state.edit ? 'Ansprechpartner bearbeiten' : 'Ansprechpartner hinzufügen'}
      wide
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            Abbrechen
          </Button>
          <Button variant="primary" onClick={submit} loading={add.isPending || upd.isPending} disabled={!f.name.trim()}>
            {state.edit ? 'Speichern' : 'Hinzufügen'}
          </Button>
        </>
      }
    >
      <div className="grid grid-cols-2 gap-4">
        <Input label="Name" value={f.name} onChange={(e) => setF((s) => ({ ...s, name: e.target.value }))} autoFocus />
        <Input
          label="Funktion / Rolle"
          value={f.role}
          onChange={(e) => setF((s) => ({ ...s, role: e.target.value }))}
        />
        <Input
          label="E-Mail"
          type="email"
          value={f.email}
          onChange={(e) => setF((s) => ({ ...s, email: e.target.value }))}
        />
        <Input label="Telefon" value={f.phone} onChange={(e) => setF((s) => ({ ...s, phone: e.target.value }))} />
        <label className="col-span-2 flex items-center gap-2 text-sm text-text-secondary">
          <input
            type="checkbox"
            checked={!!f.isPrimary}
            onChange={(e) => setF((s) => ({ ...s, isPrimary: e.target.checked }))}
          />
          primärer Ansprechpartner
        </label>
      </div>
    </Dialog>
  )
}
